import { makeAutoObservable } from "mobx";
import { RootStore } from "./rootStore";

export class GoogleAuthStore {
  rootStore: RootStore;

  credential?: string;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this);
  }

  get isLoggedIn(): boolean {
    return !!this.credential;
  }
}
